import { isServiceError } from '@meteor/error';
import { ResolvablePromise } from '@meteor/resolvable-promise';
import { getSentry } from '@meteor/sentry';
import { User, userClient } from '../client';
import { redirectToAuth } from './redirect';

let Sentry = getSentry();

let redirectToAuthIfNotAuthenticated = async <R>(fn: () => Promise<R>) => {
  if (typeof window === 'undefined') new Promise(() => {}) as Promise<R>;

  try {
    return await fn();
  } catch (err) {
    if (isServiceError(err) && err.data.code == 'unauthorized') {
      redirectToAuth(window.location.origin);

      // Noop promise to stop execution while redirecting
      return new Promise(() => {}) as Promise<R>;
    }

    Sentry.captureException(err);

    throw err;
  }
};

let firstUserPromise = new ResolvablePromise<User>();

export let fetchUserSpecial = () =>
  redirectToAuthIfNotAuthenticated(async () => {
    let u = await userClient.user.get({});
    if (!firstUserPromise.value) firstUserPromise.resolve(u);

    return u;
  });

export let withAuth = async <O>(fn: () => Promise<O>) => {
  try {
    await firstUserPromise.promise;
  } catch (err) {}

  return redirectToAuthIfNotAuthenticated(fn);
};

export let wrapWithAuth =
  <I, O>(fn: (i: I) => Promise<O>) =>
  async (i: I) =>
    withAuth(() => fn(i));
